import nowAndLater from "./nowAndLater";

nowAndLater('a[data-logout]', elements => {
    elements.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            fetch(link.href, {method: 'POST'})
                .then(() => {
                    window.location = '/';
                });
        })
    });
});
